import React, { useEffect, useState } from 'react'
import plpService from 'Services/plpService'
import { plpType } from 'Models/plpType'

interface TradersCardTableProps {
  pageNumber: number
  pageSize: number
  status: string
  onTotalChange: (total: number) => void
}

const TradersCardTable: React.FC<TradersCardTableProps> = ({
  pageNumber,
  pageSize,
  status,
  onTotalChange,
}) => {
  const [tradersCards, setTradersCards] = useState<plpType[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    const fetchTradersCards = async () => {
      try {
        setIsLoading(true)
        const res = await plpService.index(pageNumber, 'DESC', status)
        if (cancelled) return

        const data = res?.data.data
        setTradersCards(data?.dataset ?? [])
        onTotalChange(data?.total ?? 0)
      } catch {
        if (!cancelled) {
          setTradersCards([])
          onTotalChange(0)
        }
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }
    fetchTradersCards()
    return () => {
      cancelled = true
    }
  }, [pageNumber, status])

  return (
    <div className='bx-table-wrapper'>
      <table className='bx-table'>
        <thead>
          <tr>
            <th className='bx-finance__col-index'>#</th>
            <th className='bx-finance__col-investor'>Company Name</th>
            <th className='bx-finance__col-reference'>ID</th>
            <th className='bx-finance__col-amount'>Capacity</th>
            <th className='bx-finance__col-date'>Created At</th>
            <th className='bx-finance__col-status'>Status</th>
            <th className='bx-finance__col-pool'>LGA</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={7} className='bx-finance__empty'>
                Loading...
              </td>
            </tr>
          ) : tradersCards.length ? (
            tradersCards.map((r, index) => {
              const offset = (pageNumber - 1) * pageSize
              return (
                <tr key={r.id}>
                  <td className='bx-finance__col-index'>{offset + index + 1}</td>
                  <td className='bx-finance__col-investor'>{r.companyName ?? '-'}</td>
                  <td className='bx-finance__col-reference'>{r.id}</td>
                  <td className='bx-finance__col-amount'>{r.dailySalesCapacity || 0} Capacity</td>
                  <td className='bx-finance__col-date'>
                    {r.createdAtISO8601 ? new Date(r.createdAtISO8601).toLocaleString() : '-'}
                  </td>
                  <td className='bx-finance__col-status'>
                    <span
                      className={`bx-status-pill bx-status-pill--${(r.plpApplicationVerified || 'pending').toLowerCase()}`}
                    >
                      {r.plpApplicationVerified || 'Pending'}
                    </span>
                  </td>
                  <td className='bx-finance__col-pool'>{r.companyLGA || '-'}</td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan={7} className='bx-finance__empty'>
                No applications found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default TradersCardTable
